import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { createPersistStorage } from '@vipso/shared';
import authReducer from './authSlice';

const authPersistConfig = {
  key: 'vipso-demo-auth',
  storage: createPersistStorage(),
  whitelist: [
    'accessToken',
    'refreshToken',
    'user',
    'org',
    'membershipId',
    'featureKeys',
    'tenant',
    'variantName',
    'theme',
    'config',
    'tenantOrgs',
    'orgs',
    'socketRooms',
    'pendingTaskCount',
    'operationsLocked',
  ],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
